var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("This is Home Page")]),_c('p',{on:{"click":_vm.message}},[_vm._v("message")]),_c('p',{on:{"click":_vm.prompt}},[_vm._v("prompt")]),_c('p',{on:{"click":_vm.yesno}},[_vm._v("yes / no")])])}
var staticRenderFns = []

export { render, staticRenderFns }